var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_7724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.5 20 0 15.5 0 10C0 4.5 4.5 0 10 0C15.5 0 20 4.5 20 10C20 15.5 15.5 20 10 20ZM10 1.25C5.125 1.25 1.25 5.125 1.25 10C1.25 14.875 5.125 18.75 10 18.75C14.875 18.75 18.75 14.875 18.75 10C18.75 5.125 14.875 1.25 10 1.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 6.625H4.625C4.25 6.625 4 6.375 4 6C4 5.625 4.25 5.375 4.625 5.375H15.375C15.75 5.375 16 5.625 16 6C16 6.375 15.75 6.625 15.375 6.625Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 10.625H4.625C4.25 10.625 4 10.375 4 10C4 9.625 4.25 9.375 4.625 9.375H15.375C15.75 9.375 16 9.625 16 10C16 10.375 15.75 10.625 15.375 10.625Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 14.625H4.625C4.25 14.625 4 14.375 4 14C4 13.625 4.25 13.375 4.625 13.375H15.375C15.75 13.375 16 13.625 16 14C16 14.375 15.75 14.625 15.375 14.625Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_7724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.e16481ccd5368bc2fbf3eb508815898a.svg";
export { ForwardRef as ReactComponent };